import http, { HttpSuccessOrErrorType } from '../http';

export default {
  /**
   * 获取到国际化
   */
  async get_restaurant_string_id_setting_i18n_codes(
    params: { string_id: string },
  ): Promise<
    HttpSuccessOrErrorType<
      Array<{
        id: number;
        code: string;
        name: string;
      }>
    >
  > {
    const { string_id } = params;
    return await http.get(`/restaurant/${string_id}/setting_i18n_codes`);
  },

  // 根据id获取基础设置
  async getSettingById(id: number): Promise<any> {
    return await http.get(`/api/v2/settings/${id}`);
  },


  /**
   * 清空所有其他菜品标识
   */
  async deleteOtherDetailInfo(): Promise<any> {
    return await http.delete(`/api/v2/dishes/clearOtherDetailInfo`);
  },
};
